export const DEFAULT_PHASES: string[] = [
  "Aguardando atendimento Corretor",
  "Análise de Crédito Realizada",
  "Análise SAFI",
  "Aprovado SAFI",
  "Contrato com pendência comercial",
  "Contrato comunicado",
  "Contrato gerado",
  "Distratado",
  "Em Análise de Crédito",
  "Em atendimento",
  "Proposta",
  "Proposta Aprovada",
  "Proposta Reprovada",
  "Rejeitado SAFI",
  "Reprovado Comissões",
  "Repassado",
  "Visita Agendada",
  "Visita Realizada",
];
